import React from 'react';
import { UnrealizedGainLossDetails } from '../../../../tabs/GainLoss/Components/UnrealizedGainLossTab/components/UnrealizedGainLossDetails/UnrealizedGainLossDetails';

interface Props {
  title: string;
}

export const UnrealizedGainLossDetailCard = ({ title }: Props) => {
  return <UnrealizedGainLossDetails title={title} />;
};
